import '../process-es6/browser.es.js';
import { createCommonjsModule } from '../../_virtual/_commonjsHelpers.es.js';
import '../@babel/runtime/helpers/typeof.es.js';
import reactIs_development from './cjs/react-is.development.es.js';

var reactIs = createCommonjsModule(function (module) {

  {
    module.exports = reactIs_development;
  }
});

export { reactIs as __moduleExports, reactIs as default };
